// extracted by mini-css-extract-plugin
export default {"error-panel":"E00XKPOBULfuTBSGLd6Ra","error-panel__dismiss":"_622Z7g0BabbSj9frPZqnmP"};